import React from 'react';
import ContentLoader from 'react-content-loader';
import styled from 'styled-components';
import { useDeviceType } from '@hotelplan/libs.context.device-type';
import { sx2CssThemeFn } from '@hotelplan/util.theme.sxc';
import {
  COMPARE_ITEMS_COUNT_DESKTOP,
  COMPARE_ITEMS_COUNT_MOBILE,
} from 'fdr/components/local/fdr-wishlist/fdr-wishlist.constants';
import {
  WishlistItemSelectSkeletonWrapper,
  WishlistItemsWrapper,
} from './WishlistItemSelect.skeleton';

const ContentLoaderWrapper = styled.div(
  sx2CssThemeFn({
    backgroundColor: 'white',
    mt: [4, 3],
    width: '100%',
  })
);

const WishlistListCompareViewItemSkeleton: React.FC<{
  className?: string;
}> = ({ className }) => {
  const { mobile } = useDeviceType();

  return (
    <ContentLoaderWrapper className={className}>
      <ContentLoader
        speed={2}
        width={mobile ? 325 : 270}
        height={mobile ? 1112 : 1361}
        style={{
          width: '100%',
          height: mobile ? '1112px' : '1361px',
        }}
      >
        {mobile ? (
          <>
            <rect width="325" height="1" />
            <rect x="16" y="17" width="139" height="1" />
            <rect x="16" y="126" width="139" height="1" />
            <rect x="16" y="17" width="1" height="109" />
            <rect x="154" y="17" width="1" height="109" />
            <path d="M26 18H98V50C98 52.2091 96.2091 54 94 54H30C27.7909 54 26 52.2091 26 50V18Z" />
            <circle cx="26" cy="153" r="10" />
            <circle cx="49" cy="153" r="10" />
            <circle cx="72" cy="153" r="10" />
            <circle cx="95" cy="153" r="10" />
            <circle cx="117" cy="153" r="10" />
            <rect x="16" y="175" width="130" height="13" rx="6.5" />
            <rect x="16" y="195" width="99" height="13" rx="6.5" />
            <rect x="169" y="17" width="139" height="1" />
            <rect x="169" y="126" width="139" height="1" />
            <rect x="169" y="17" width="1" height="109" />
            <rect x="307" y="17" width="1" height="109" />
            <path d="M179 18H251V50C251 52.2091 249.209 54 247 54H183C180.791 54 179 52.2091 179 50V18Z" />
            <circle cx="179" cy="153" r="10" />
            <circle cx="202" cy="153" r="10" />
            <circle cx="225" cy="153" r="10" />
            <circle cx="248" cy="153" r="10" />
            <circle cx="270" cy="153" r="10" />
            <rect x="169" y="175" width="130" height="13" rx="6.5" />
            <rect x="169" y="195" width="99" height="13" rx="6.5" />
            <rect x="45" y="275" width="81" height="13" rx="6.5" />
            <rect x="45" y="299" width="65" height="13" rx="6.5" />
            <rect x="68" y="330" width="73" height="13" rx="6.5" />
            <rect x="16" y="363" width="75" height="13" rx="6.5" />
            <rect x="16" y="387" width="39" height="13" rx="6.5" />
            <rect x="16" y="411" width="48" height="13" rx="6.5" />
            <rect x="74" y="387" width="39" height="13" rx="6.5" />
            <rect x="16" y="330" width="45" height="13" rx="6.5" />
            <rect x="68" y="450" width="73" height="13" rx="6.5" />
            <rect x="16" y="483" width="75" height="13" rx="6.5" />
            <rect x="16" y="507" width="39" height="13" rx="6.5" />
            <rect x="16" y="531" width="48" height="13" rx="6.5" />
            <rect x="45" y="586" width="110" height="15" rx="7.5" />
            <rect x="16" y="642" width="57" height="15" rx="7.5" />
            <rect x="16" y="706" width="67" height="15" rx="7.5" />
            <rect x="16" y="731" width="108" height="15" rx="7.5" />
            <rect x="16" y="756" width="92" height="15" rx="7.5" />
            <rect x="16" y="778" width="69" height="15" rx="7.5" />
            <rect x="16" y="803" width="98" height="15" rx="7.5" />
            <rect x="16" y="859" width="92" height="15" rx="7.5" />
            <rect x="16" y="881" width="69" height="15" rx="7.5" />
            <rect x="16" y="906" width="98" height="15" rx="7.5" />
            <rect x="16" y="931" width="98" height="15" rx="7.5" />
            <rect x="16" y="834" width="69" height="15" rx="7.5" />
            <rect x="16" y="618" width="139" height="15" rx="7.5" />
            <rect x="74" y="507" width="39" height="13" rx="6.5" />
            <rect x="16" y="450" width="45" height="13" rx="6.5" />
            <rect y="252" width="325" height="1" />
            <rect y="565" width="325" height="1" />
            <rect y="974" width="325" height="1" />
            <rect y="1111" width="325" height="1" />
            <rect width="1" height="1111" />
            <rect x="324" width="1" height="1111" />
            <circle cx="26" cy="292" r="10" />
            <rect x="202" y="275" width="81" height="13" rx="6.5" />
            <rect x="202" y="299" width="65" height="13" rx="6.5" />
            <rect x="225" y="330" width="73" height="13" rx="6.5" />
            <rect x="173" y="363" width="75" height="13" rx="6.5" />
            <rect x="173" y="387" width="39" height="13" rx="6.5" />
            <rect x="173" y="411" width="48" height="13" rx="6.5" />
            <rect x="231" y="387" width="39" height="13" rx="6.5" />
            <rect x="173" y="330" width="45" height="13" rx="6.5" />
            <rect x="225" y="450" width="73" height="13" rx="6.5" />
            <rect x="173" y="483" width="75" height="13" rx="6.5" />
            <rect x="173" y="507" width="39" height="13" rx="6.5" />
            <rect x="173" y="531" width="48" height="13" rx="6.5" />
            <rect x="231" y="507" width="39" height="13" rx="6.5" />
            <rect x="173" y="450" width="45" height="13" rx="6.5" />
            <circle cx="183" cy="292" r="10" />
            <circle cx="26" cy="594" r="10" />
            <rect x="203" y="586" width="110" height="15" rx="7.5" />
            <rect x="174" y="642" width="57" height="15" rx="7.5" />
            <rect x="174" y="706" width="67" height="15" rx="7.5" />
            <rect x="174" y="731" width="108" height="15" rx="7.5" />
            <rect x="174" y="756" width="92" height="15" rx="7.5" />
            <rect x="174" y="778" width="69" height="15" rx="7.5" />
            <rect x="174" y="803" width="98" height="15" rx="7.5" />
            <rect x="174" y="859" width="92" height="15" rx="7.5" />
            <rect x="174" y="881" width="69" height="15" rx="7.5" />
            <rect x="174" y="906" width="98" height="15" rx="7.5" />
            <rect x="174" y="931" width="98" height="15" rx="7.5" />
            <rect x="174" y="834" width="69" height="15" rx="7.5" />
            <rect x="174" y="618" width="139" height="15" rx="7.5" />
            <circle cx="184" cy="594" r="10" />
            <rect x="16" y="991" width="139" height="1" />
            <rect x="171" y="991" width="139" height="1" />
            <rect x="171" y="1094" width="139" height="1" />
            <rect x="16" y="1094" width="139" height="1" />
            <rect x="16" y="992" width="1" height="102" />
            <rect x="154" y="992" width="1" height="102" />
            <rect x="171" y="992" width="1" height="102" />
            <rect x="309" y="992" width="1" height="102" />
            <circle cx="136" cy="1043" r="9" />
            <rect x="32" y="1008" width="71" height="14" rx="7" />
            <rect x="32" y="1024" width="56" height="14" rx="7" />
            <rect x="32" y="1048" width="71" height="14" rx="7" />
            <rect x="32" y="1064" width="56" height="14" rx="7" />
            <circle cx="290" cy="1043" r="9" />
            <rect x="186" y="1008" width="71" height="14" rx="7" />
            <rect x="186" y="1024" width="56" height="14" rx="7" />
            <rect x="186" y="1048" width="71" height="14" rx="7" />
            <rect x="186" y="1064" width="56" height="14" rx="7" />
          </>
        ) : (
          <>
            <rect x="269" y="1" width="1" height="1360" />
            <rect y="1" width="1" height="1360" />
            <rect width="270" height="1" />
            <rect y="137" width="270" height="1" />
            <rect y="249" width="270" height="1" />
            <path d="M10 1H144V27C144 29.2091 142.209 31 140 31H14C11.7909 31 10 29.2091 10 27V1Z" />
            <circle cx="25" cy="163" r="10" />
            <circle cx="50" cy="163" r="10" />
            <circle cx="76" cy="163" r="10" />
            <circle cx="101" cy="163" r="10" />
            <circle cx="125" cy="163" r="10" />
            <circle cx="27" cy="278" r="10" />
            <rect x="15" y="187" width="169" height="16" rx="8" />
            <rect x="15" y="213" width="126" height="16" rx="8" />
            <rect x="48" y="270" width="160" height="16" rx="8" />
            <circle cx="27" cy="318" r="10" />
            <rect x="48" y="310" width="160" height="16" rx="8" />
            <circle cx="29" cy="432" r="10" />
            <rect x="50" y="424" width="160" height="16" rx="8" />
            <circle cx="29" cy="561" r="10" />
            <rect x="50" y="553" width="160" height="16" rx="8" />
            <rect x="17" y="624" width="218" height="17" rx="8" />
            <rect x="17" y="655" width="212" height="17" rx="8" />
            <rect x="17" y="686" width="202" height="17" rx="8" />
            <rect x="19" y="594" width="66" height="16" rx="8" />
            <rect x="19" y="758" width="218" height="17" rx="8" />
            <rect x="19" y="789" width="212" height="17" rx="8" />
            <rect x="19" y="820" width="202" height="17" rx="8" />
            <rect x="21" y="728" width="66" height="16" rx="8" />
            <rect x="19" y="462" width="131" height="16" rx="8" />
            <rect x="19" y="492" width="176" height="16" rx="8" />
            <rect x="19" y="348" width="134" height="16" rx="8" />
            <rect x="19" y="378" width="176" height="16" rx="8" />
            <rect x="17" y="532" width="236" height="1" />
            <rect x="15" y="859" width="240" height="1" />
            <rect x="20" y="977" width="232" height="1" />
            <rect x="20" y="1036" width="232" height="1" />
            <rect x="20" y="1095" width="232" height="1" />
            <rect x="20" y="1154" width="232" height="1" />
            <rect x="15" y="876" width="240" height="1" />
            <rect x="15" y="913" width="240" height="1" />
            <rect x="15" y="877" width="1" height="37" />
            <rect x="254" y="877" width="1" height="37" />
            <rect x="97" y="885" width="148" height="20" rx="10" />
            <rect x="15" y="919" width="240" height="1" />
            <rect x="15" y="956" width="240" height="1" />
            <rect x="15" y="920" width="1" height="37" />
            <rect x="254" y="920" width="1" height="37" />
            <rect x="97" y="928" width="148" height="20" rx="10" />
            <ellipse cx="32.5" cy="1007" rx="13.5" ry="13" />
            <circle cx="242.5" cy="1005.5" r="6.5" />
            <rect x="55" y="998" width="49" height="20" rx="8" />
            <ellipse cx="32.5" cy="1066" rx="13.5" ry="13" />
            <circle cx="242.5" cy="1064.5" r="6.5" />
            <rect x="55" y="1057" width="104" height="20" rx="8" />
            <ellipse cx="32.5" cy="1124" rx="13.5" ry="13" />
            <circle cx="242.5" cy="1122.5" r="6.5" />
            <rect x="55" y="1115" width="167" height="20" rx="8" />
            <rect x="20" y="1213" width="232" height="1" />
            <rect x="1" y="1310" width="269" height="1" />
            <rect x="1" y="1360" width="269" height="1" />
            <ellipse cx="32.5" cy="1183" rx="13.5" ry="13" />
            <circle cx="242.5" cy="1181.5" r="6.5" />
            <circle cx="87" cy="1243" r="10" />
            <circle cx="111" cy="1243" r="10" />
            <circle cx="183" cy="1243" r="10" />
            <circle cx="159" cy="1243" r="10" />
            <circle cx="135" cy="1243" r="10" />
            <rect x="55" y="1174" width="167" height="20" rx="8" />
            <rect x="77" y="1272" width="117" height="16" rx="8" />
            <rect x="63" y="1326" width="145" height="19" rx="8" />
            <rect x="20" y="1230" width="45" height="26" rx="10" />
            <rect x="21" y="1270" width="51" height="20" rx="10" />
          </>
        )}
      </ContentLoader>
    </ContentLoaderWrapper>
  );
};

const WishlistListCompareViewItemSkeletonWrapper = styled.div(
  sx2CssThemeFn({
    width: ['50%', `${100 / 3}%`],
    mx: [2, 3],
  })
);

const WishlistListCompareViewContentSkeleton: React.FC = () => {
  const { mobile } = useDeviceType();

  return (
    <WishlistItemSelectSkeletonWrapper>
      <WishlistItemsWrapper>
        {mobile ? (
          <WishlistListCompareViewItemSkeleton />
        ) : (
          Array.from({
            length: mobile
              ? COMPARE_ITEMS_COUNT_MOBILE
              : COMPARE_ITEMS_COUNT_DESKTOP,
          }).map((_, i) => (
            <WishlistListCompareViewItemSkeletonWrapper key={`skeleton-${i}`}>
              <WishlistListCompareViewItemSkeleton />
            </WishlistListCompareViewItemSkeletonWrapper>
          ))
        )}
      </WishlistItemsWrapper>
    </WishlistItemSelectSkeletonWrapper>
  );
};

export default WishlistListCompareViewContentSkeleton;
